import React from 'react';
import { Redirect, useLocation, withRouter, matchPath } from 'react-router';
import {
  usePermissions,
  useLogin,
} from '../redux/reducers/gl_auth_reducer/selectors';
import NavigationConfig from '../navigation/config';
import { IRequireAuthProps, IWithnavbarProps } from './types';
import * as ThemeSelectors from 'redux/reducers/gl_theme_reducer/selectors';
import CustomSuspense from 'components/molecules/CustomSuspense';
import PermissionsEnum from 'constants/permissions';
import { userHasAccess } from 'services/local/permissions';
import { useHostDetails } from 'redux/reducers/gl_host_provider/selectors';
import _ from 'lodash';

export const RequireAuth = ({
  Component,
  requiredLogin,
  id,
  pageType,
}: IRequireAuthProps): any => {
  // const userRoles = useSelectUserRoles();
  const permissions = usePermissions();
  const isLogin = useLogin();
  const { data } = useHostDetails();

  // data?.settings

  console.log('Require auth..', requiredLogin);

  return userHasAccess({
    isLogin: Boolean(isLogin),
    userPermissionsMap: permissions || null,
    requiredPermission: (id as any) || null,
    requiredLogin: requiredLogin || null,
    pageType: pageType || null,
    settingsMap: data?.settings || null,
  }) ? (
    <CustomSuspense>
      <Component />
    </CustomSuspense>
  ) : (
    <Redirect to={NavigationConfig.mainPage().path} />
  );
};

// export const withRoles = (Component: any, roles: Array<Roles>): any => {
//   const ComposedComponent = (props: any) => {
//     const userRoles = useSelectUserRoles();
//     return ArrayUtils.arraysHasCommonElements(roles, userRoles) ? (
//       <Component {...props} />
//     ) : null;
//   };

//   return ComposedComponent;
// };

export const WithNavbar = withRouter((props: IWithnavbarProps): any => {
  const location = useLocation();
  const { Component, select, include, exclude } = props;
  const path = location.pathname;
  let visible: boolean = false;
  const accessFromMobileDev = ThemeSelectors.useIsMobileAppAccess();
  // reactLogger.log('Call Withnumber', accessFromMobileDev, location);

  const arrayMatch = (_paths: string[], _path: string): boolean => {
    for (let ___path of _paths) {
      if (
        matchPath(_path, {
          path: ___path,
          exact: true,
          strict: false,
        })?.isExact
      ) {
        return true;
      }
    }
    return false;
  };

  if (select === 'exclude') {
    visible =
      exclude !== 'all' && Array.isArray(exclude) && !arrayMatch(exclude, path);
  } else if (select === 'include') {
    visible =
      include === 'all' ||
      (Array.isArray(include) && arrayMatch(include, path));
  }

  return (
    <React.Fragment>
      <Component visible={accessFromMobileDev ? false : visible} />
    </React.Fragment>
  );
});

export function withPermissions<T>(
  Component: React.FC<T>,
  permission: PermissionsEnum
) {
  const ComposedComponent: React.FC<T> = (props) => {
    const permissions = usePermissions();
    return permission in (permissions || {}) ? <Component {...props} /> : null;
  };

  return ComposedComponent;
}

interface IPermissionsProps {
  permission: PermissionsEnum;
  children: React.ReactNode;
}
export const WithPermission = ({ children, permission }: IPermissionsProps) => {
  const permissions = usePermissions();
  return permission in (permissions || {}) ? (
    <React.Fragment>{children}</React.Fragment>
  ) : null;
};

export const WithoutPermission = ({
  children,
  permission,
}: IPermissionsProps) => {
  const permissions = usePermissions();
  return !(permission in (permissions || {})) ? (
    <React.Fragment>{children}</React.Fragment>
  ) : null;
};

export const withTemplate = (
  templateId: string,
  templetedMap: {
    [key: string]: React.FC<any>;
  }
) => {
  const ComposedComponent = (props: any) => {
    const hostDetails = useHostDetails();

    const Template = _.get(
      templetedMap,
      _.get(hostDetails.data?.settings, templateId) ?? ''
    );

    return Template ? <Template {...props} /> : <div>TEMPLATE NOT FOUND</div>;
  };

  return ComposedComponent;
};

export const requiredLogin = (
  Component: React.FC<any>,
  requiredLogin: boolean = true
) => {
  const ComposedComponent = (props: any) => {
    const isLogin = useLogin();
    return (requiredLogin && isLogin) || (!requiredLogin && !isLogin) ? (
      <Component {...props} />
    ) : null;
  };

  return ComposedComponent;
};

interface IRequireLoginProps {
  requireLogin?: boolean;
  children: React.ReactNode;
}
export const RequireLogin = ({
  children,
  requireLogin = true,
}: IRequireLoginProps) => {
  const isLogin = useLogin();
  return (requireLogin && isLogin) || (!requireLogin && !isLogin) ? (
    <React.Fragment>{children}</React.Fragment>
  ) : null;
};
